<template>
  <el-dropdown class="theme-switcher" trigger="click" @command="handleThemeChange">
    <button class="nav-action theme-switcher__trigger" type="button">
      <i :class="currentOption.icon"/>
      <span>{{ currentOption.label }}</span>
    </button>
    <el-dropdown-menu slot="dropdown" class="theme-switcher__menu">
      <el-dropdown-item
          v-for="item in themeOptions"
          :key="item.value"
          :class="{ 'is-active': item.value === theme }"
          :command="item.value"
      >
        <i :class="item.icon"/>
        <span>{{ item.label }}</span>
        <i v-if="item.value === theme" class="el-icon-check theme-switcher__check"/>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getThemeOption} from '@/utils/theme'

export default {
  name: 'ThemeSwitcher',
  computed: {
    ...mapGetters(['theme', 'themeOptions']),
    currentOption() {
      return getThemeOption(this.theme)
    },
  },
  methods: {
    ...mapActions('theme', ['setTheme']),
    handleThemeChange(theme) {
      this.setTheme(theme)
    },
  },
}
</script>

<style lang="scss" scoped>
.theme-switcher {
  &__trigger {
    min-width: 108px;
    justify-content: center;
  }

  &__check {
    margin-left: auto;
    color: var(--app-primary, #1677ff);
    font-weight: 700;
  }
}
</style>

<style lang="scss">
.theme-switcher__menu {
  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 140px;

    i:first-child {
      width: 16px;
      text-align: center;
    }

    &.is-active {
      color: var(--app-primary, #1677ff);
      background: var(--app-nav-action-hover-bg, #f0f5ff);
    }
  }
}
</style>
